/** zh-CN catalogue `easing` (W3-09; English: src/features/easing/easing.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'easing',
  locale: 'zh-CN',
  messages: {
    title: '要怎样运动？',
    searchLabel: '搜索缓动',
    searchPlaceholder: 'out quad、oq、4、bouncy…',
    gridLabel: '缓动',
    topRowLabel: '基础缓动',
    rowLabel: '{strength}（{family}）',
    cellName: '{strength}，{shape}',
    cellNameFull: '{strength}，{shape}：{rpeName}（{id}）',
    cellApprox: '{strength}，{shape}：拟合 {name} 的自定义曲线，偏差 {error}%',
    linear: '线性',
    hold: '钩定（保持后跳变）',
    holdShort: '钩定',
    approxBadge: '拟合',
    approxTip: 'RPE 中没有 {name} 的编号：这是拟合 Phira 缓动的自定义曲线，偏差最多 {error}%。',
    differsTip: 'Phira 绘制此缓动的方式与 RPE 不同。',
    overshootTip: '此缓动会超出起始值和结束值。',
    overshootWarning: '文字的缓动超出范围时，Phira 会显示多余或缺失的字符（警告 PH-16）。',
    bakedBadge: '导出时烘焙',
    bakedTip: '在此流速模式下 Phira 将流速播放为直线渐变：导出时带缓动的流速会被转换为直线分段。',
    favouriteBadge: '收藏',
    noResults: '没有与“{query}”匹配的缓动。',
    resultsLabel: '匹配的缓动',
    tabCurves: '缓动',
    tabBezier: '自定义曲线',
    tabsLabel: '曲线类型',
    bezierHidden: '此处不能使用自定义曲线：{reason}',
    bakeOffer: '烘焙为直线分段…',
    bakeHint: '特效和视频的数值不能使用自定义曲线。烘焙会把运动写为许多短直线分段。',
    speedGuidedHint: 'Phira 将流速变化播放为直线渐变。请选择“线性”或“钩定”，或切换到完整模式。',
    revealHint: '逐字显示和擦除文字不能使用超出范围的缓动：Phira 会崩溃。',
    controlHint: '距离控制只能使用 RPE 的带编号缓动。',
    preview: '预览',
    previewOf:
      '{prop, select, moveX {X 位置} moveY {Y 位置} rotate {旋转} alpha {不透明度} speed {流速} scaleX {长度 / X 尺寸} scaleY {粗细 / Y 尺寸} color {颜色} text {文字} incline {倾斜} paint {画笔} gif {GIF 进度} none {数值} other {{prop}}}：在 {beats} 内从 {from} 变到 {to}',
    previewNoSegment: '曲线从起点到终点的形状。',
    previewLive: '预览会用此缓动播放该区段；选定之前不会做任何更改。',
    plotLabel: '数值随时间的变化：{name}',
    plotCurrent: '当前缓动',
    recents: '最近使用',
    favourites: '收藏',
    noFavourites: '在缓动上按 F 即可收藏到这里。',
    addFavourite: '添加到收藏（F）',
    removeFavourite: '从收藏中移除（F）',
    appliesTo: '应用于 {count, plural, other {# 个区段}}',
    skipped: '{count} 个区段中有 {skipped} 个不能使用此缓动：{reason}',
    noneApplies: '选中的区段都不能使用此缓动：{reason}',
    keysHint: '方向键移动 · Enter 选定 · 输入 RPE 编号 · / 搜索 · B 自定义曲线 · Tab 曲线的一部分 · F 收藏 · Esc 取消',
    keysHintGuided: '方向键移动 · Enter 选定 · 输入 RPE 编号 · / 搜索 · F 收藏 · Esc 取消',
    apply: '使用此缓动',
    cancel: '取消',
    current: '当前',
    ids: 'RPE 编号',
    sliceTitle: '缓动切割（使用曲线的一部分）',
    sliceStart: '部分的起点',
    sliceEnd: '部分的终点',
    sliceWhole: '整条曲线',
    sliceReset: '使用整条曲线',
    sliceLinear: '线性没有可切割的形状：Phira 会忽略切割。',
    sliceNotTween: '只有带编号的缓动才能使用曲线的一部分。',
    sliceControl: '距离控制总是使用整条曲线。',
    sliceEmpty: '部分的起点必须在终点之前。',
    sliceDegenerate: '这一部分起点和终点高度相同：Phira 无法拉伸它，将不显示任何运动。',
    sliceRange: '{left} 到 {right}',
    bezierTitle: '自定义曲线（贝塞尔）',
    bezierCanvas: '曲线编辑器。拖动两个控制柄，或聚焦一个控制柄后使用方向键（Shift：步长更大）。',
    handleStart: '起点控制柄',
    handleEnd: '终点控制柄',
    handleValue: 'x {x}，y {y}',
    x1: '起点控制柄 X',
    y1: '起点控制柄 Y',
    x2: '终点控制柄 X',
    y2: '终点控制柄 Y',
    pasteLabel: '粘贴 cubic-bezier',
    pastePlaceholder: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    pasteApply: '使用',
    pasteInvalid: '请写四个数字，例如 cubic-bezier(0.25, 0.1, 0.25, 1)。',
    pasteXRange: '控制柄的 X 值必须在 0 到 1 之间：已将其限制在范围内。',
    pasted: '已粘贴 {value}。',
    copyCss: '复制为 cubic-bezier',
    copiedCss: '已复制 {value}。',
    snap: '吸附到 0.01',
    presets: '预设',
    presetsLabel: '预设曲线',
    'preset.ease': 'Ease',
    'preset.easeIn': '缓入',
    'preset.easeOut': '缓出',
    'preset.easeInOut': '缓入缓出',
    'preset.quintInOut': '更强，两端慢（拟合）',
    'preset.expoInOut': '极强，两端慢（拟合）',
    overshootNote: '此曲线会超出起始值或结束值。',
    collisionTitle: 'Phira 会让此曲线与{count, plural, other {另外 # 条曲线}}共用',
    collisionOthers:
      'Phira 会将控制柄取整到 0.01，每组取整后的值只保留一条曲线。{lines} 上的{count, plural, other {曲线}}也会被取整为相同的值。',
    collisionDrawnWith: 'Phira 会用最先出现的曲线的控制柄 {points} 来绘制此曲线。',
    collisionOwnFirst: '此曲线最先出现：Phira 会用这些控制柄绘制其他曲线。',
    collisionFix: '请将一个控制柄移动 0.01，或使用完全相同的控制柄。',
    bezierApply: '使用此曲线',
    notice: '{text}',
    cmdCopy: '复制缓动',
    cmdPaste: '粘贴缓动',
    cmdBezier: '自定义曲线（贝塞尔）…',
    cmdPick: '更改缓动…',
    cmdSet: '缓动：{name}',
    cmdClearRecents: '清除最近使用的缓动',
    cmdTemplates: '运动模板…',
    copiedCurve: '已复制缓动：{name}。',
    pastedCurve: '已将缓动粘贴到 {count, plural, other {# 个区段}}。',
    setCurve: '已为 {count, plural, other {# 个区段}}设置缓动。',
    noCurveCopied: '请先复制一个缓动。',
    noSegments: '请先选中一个或多个区段。',
    noProject: '请先打开一个项目。',
    noActiveLine: '请先选择一条判定线。',
    recentsCleared: '已清除最近使用的缓动。',
    txSetCurve: '设置缓动：{name}',
    txPasteCurve: '粘贴缓动',
    txBezier: '自定义曲线',
    'set.1': '缓动：线性（1）',
    'set.hold': '缓动：钩定（保持后跳变）',
    'set.2': '缓动：轻柔，慢停（OutSine，2）',
    'set.3': '缓动：轻柔，慢起（InSine，3）',
    'set.4': '缓动：柔和，慢停（OutQuad，4）',
    'set.5': '缓动：柔和，慢起（InQuad，5）',
    'set.6': '缓动：轻柔，两端慢（InOutSine，6）',
    'set.7': '缓动：柔和，两端慢（InOutQuad，7）',
    'set.8': '缓动：适中，慢停（OutCubic，8）',
    'set.9': '缓动：适中，慢起（InCubic，9）',
    'set.10': '缓动：较强，慢停（OutQuart，10）',
    'set.11': '缓动：较强，慢起（InQuart，11）',
    'set.12': '缓动：适中，两端慢（InOutCubic，12）',
    'set.13': '缓动：较强，两端慢（InOutQuart，13）',
    'set.14': '缓动：更强，慢停（OutQuint，14）',
    'set.15': '缓动：更强，慢起（InQuint，15）',
    'set.16': '缓动：极强，慢停（OutExpo，16）',
    'set.17': '缓动：极强，慢起（InExpo，17）',
    'set.18': '缓动：陡峭，慢停（OutCirc，18）',
    'set.19': '缓动：陡峭，慢起（InCirc，19）',
    'set.20': '缓动：过冲，慢停（OutBack，20）',
    'set.21': '缓动：过冲，慢起（InBack，21）',
    'set.22': '缓动：陡峭，两端慢（InOutCirc，22）',
    'set.23': '缓动：过冲，两端慢（InOutBack，23）',
    'set.24': '缓动：弹簧，慢停（OutElastic，24）',
    'set.25': '缓动：弹簧，慢起（InElastic，25）',
    'set.26': '缓动：弹跳，慢停（OutBounce，26）',
    'set.27': '缓动：弹跳，慢起（InBounce，27）',
    'set.28': '缓动：弹跳，两端慢（InOutBounce，28）',
    'set.29': '缓动：弹簧，两端慢（InOutElastic，29）',
    'set.quintInOut': '缓动：更强，两端慢（拟合的自定义曲线）',
    'set.expoInOut': '缓动：极强，两端慢（拟合的自定义曲线）',
    settingFavourites: '缓动收藏与最近使用',
    settingFavouritesHelp: '缓动选择器中保存的缓动。清除即可重新开始。',
    clearFavourites: '清除收藏',
    clearRecents: '清除最近使用',
    favouritesCount:
      '{favourites, plural, =0 {没有收藏} other {# 个收藏}}，{recents, plural, =0 {没有最近使用的缓动} other {# 个最近使用的缓动}}',
    settingShowIds: '缓动选择器：始终显示 RPE 编号',
    settingShowIdsHelp: '在每个缓动上显示 RPE 缓动编号，在引导模式下也显示。',
    helpTitle: '选择运动方式',
    helpBody:
      '两个关键帧之间的每个区段都有一个缓动。行表示强度（从“轻柔”到“弹跳”），列表示运动在哪里慢：结尾、开头或两端。将鼠标悬停在缓动上可在真实的判定线上预览；按 Enter 或单击即可使用。输入 RPE 编号（片刻内输入两位数字），按 / 搜索（“out quad”“oq”“4”），按 F 收藏。完整模式还会显示 RPE 编号，可以只使用曲线的一部分，也可以绘制自定义贝塞尔曲线（按 B，用方向键移动控制柄，Enter 使用，B 返回网格）。',
    helpTemplatesTitle: '运动模板',
    helpTemplatesBody:
      '模板会为常见运动写入普通关键帧：淡入淡出、滑入滑出、移动到一个点、旋转、摇摆、脉动、抖动、闪烁颜色和环绕父线。调整时预览会循环播放这段范围；“应用”会将其作为一个可撤销的步骤。在完整模式下，模板可以放在新层级上，使现有关键帧保持不变。',
  },
};

export default catalog;
